const DIFFICULTY = [
  {
    key: '0',
    text: 'Any Difficulty',
    value: "any",
  },
  {
    key: 'easy',
    text: 'Easy',
    value: 'easy',
  },
  {
    key: 'medium',
    text: 'Medium',
    value: 'medium',
  },
  {
    key: 'hard',
    text: 'Hard',
    value: 'hard',
  },
];

export default DIFFICULTY;
